import { createSlice } from '@reduxjs/toolkit'
import {getFactoryProvinces, getFactoryProvincesWithOffices, getProvinces, getTerminationsFactoryProvinces} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  provinces: {
      elements: [],
      loading: "idle",
      error: null
  },
  provincesWithOffices:{
    elements: [],
    loading: "idle",
    error: null
  },
  terminationProvinces:{
    elements: [],
    loading: "idle",
    error: null
  }  
  }

const factoryProvincesSlice = createSlice({
  name: 'factoryProvinces',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryProvinces.pending]: (state) => {
        state.provinces.loading = "loading"; 
        state.provinces.error = null
      },
    [getFactoryProvinces.fulfilled]: (state, action) => {
    state.provinces.loading = "succeeded";
    state.provinces.elements = action.payload
      
    },
    [getFactoryProvinces.rejected]: (state, action) => {
        state.provinces.loading = "failed"; 
        state.provinces.error = action.error.message
      },
      [getFactoryProvincesWithOffices.pending]: (state) => {
        state.provincesWithOffices.loading = "loading"; 
        state.provincesWithOffices.error = null
      },
    [getFactoryProvincesWithOffices.fulfilled]: (state, action) => {
    state.provincesWithOffices.loading = "succeeded";
    state.provincesWithOffices.elements = action.payload
      
    },
    [getFactoryProvincesWithOffices.rejected]: (state, action) => {
        state.provincesWithOffices.loading = "failed"; 
        state.provincesWithOffices.error = action.error.message
      },
    [getTerminationsFactoryProvinces.pending]: (state) => {
        state.terminationProvinces.loading = "loading"; 
        state.terminationProvinces.error = null
      },
    [getTerminationsFactoryProvinces.fulfilled]: (state, action) => {
    state.terminationProvinces.loading = "succeeded";
    state.terminationProvinces.elements = action.payload
      
    },
    [getTerminationsFactoryProvinces.rejected]: (state, action) => {
        state.terminationProvinces.loading = "failed"; 
        state.terminationProvinces.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryProvincesSlice.actions;
export default factoryProvincesSlice.reducer
